export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  longDescription: string;
  image: string;
  tags: string[];
  director: string;
  actors: string[];
  region: string;
  duration: string;
  updateStatus: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  featuredOrder?: number;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
}

export const categories: Category[] = [
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'drama', icon: 'ri-tv-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '长安三万里',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 9.2,
    description: '追光动画十年之作，以李白与高适的友情为线索，展现盛唐诗人波澜壮阔的一生。画面精美绝伦，诗词歌赋融入其中，带你穿越千年大唐风华。',
    longDescription: '《长安三万里》是追光动画倾力打造的史诗级动画电影。影片以高适的视角，回顾了他与李白跨越数十年的深厚友谊，同时展现了大唐由盛转衰的历史画卷。片中融入了四十八首经典唐诗，将中国传统文化之美展现得淋漓尽致。画面制作精良，每一帧都堪称壁纸级别，配乐大气磅礴，是近年来国产动画的巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animated%20film%20poster%20style%2C%20ancient%20Tang%20dynasty%20poets%20Li%20Bai%20and%20Gao%20Shi%20riding%20horses%20under%20moonlight%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%20blended%20with%20modern%203D%20animation%2C%20dramatic%20composition%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20cinematic%20lighting&width=800&height=1120&seq=video-v001&orientation=portrait',
    tags: ['动画', '历史', '诗词', '追光动画'],
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    duration: '168分钟',
    updateStatus: '已完结',
    views: 28560000,
    isHot: true,
    isNew: false,
    featuredOrder: 1,
  },
  {
    id: 'v002',
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movie',
    year: 2024,
    rating: 9.5,
    description: '太阳急速老化，人类面临前所未有的生存危机。地球踏上漂泊之旅，人类的勇气与坚毅将永刻于星空之下。国产科幻里程碑续作，视觉震撼。',
    longDescription: '《流浪地球3》延续了前作的宏大世界观，故事发生在太阳急速衰老膨胀的背景下，人类启动"流浪地球"计划，倾全球之力建造上万座行星发动机，推动地球离开太阳系。本片在特效制作上达到了新的高度，太空场景的恢弘与细节的精致令人叹为观止。剧情方面也更加成熟，探讨了人类在面对末日危机时的选择与牺牲。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20poster%20style%2C%20massive%20planet%20engines%20pushing%20Earth%20through%20deep%20space%2C%20astronauts%20floating%20in%20front%20of%20glowing%20engine%20thrust%2C%20epic%20cinematic%20composition%2C%20dark%20space%20with%20blue-orange%20engine%20glow%2C%20dramatic%20lighting&width=800&height=1120&seq=video-v002&orientation=portrait',
    tags: ['科幻', '灾难', '太空', '吴京'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '173分钟',
    updateStatus: '已完结',
    views: 52300000,
    isHot: true,
    isNew: false,
    featuredOrder: 2,
  },
  {
    id: 'v003',
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'drama',
    year: 2024,
    rating: 9.3,
    description: '范闲从北齐归来，面对更加复杂的朝堂斗争与江湖恩怨。权谋升级，笑料不断，张若昀携原班人马悉数回归，年度最受期待古装大剧。',
    longDescription: '《庆余年第二季》延续第一季的精彩故事，范闲率领使团从北齐回归后，发现南庆朝堂局势更加波诡云谲。二皇子、太子、长公主各方势力暗流涌动，范闲在权力的漩涡中步步为营。本季剧情更加紧凑，权谋线更加烧脑，同时保留了第一季的幽默风格。张若昀、陈道明、吴刚等实力派演员的精彩演绎，让这部古装权谋大剧成为年度必看之作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20style%2C%20handsome%20male%20lead%20in%20ancient%20Chinese%20robe%20holding%20a%20fan%20standing%20in%20imperial%20palace%2C%20dramatic%20side%20lighting%2C%20rich%20deep%20red%20and%20gold%20color%20palette%2C%20cinematic%20composition&width=800&height=1120&seq=video-v003&orientation=portrait',
    tags: ['古装', '权谋', '喜剧', '张若昀'],
    director: '孙皓',
    actors: ['张若昀', '陈道明', '吴刚', '李沁'],
    region: '中国大陆',
    duration: '45分钟/集 共36集',
    updateStatus: '已完结',
    views: 89200000,
    isHot: true,
    isNew: true,
    featuredOrder: 3,
  },
  {
    id: 'v004',
    title: '大秦帝国之天下',
    category: '电视剧',
    categorySlug: 'drama',
    year: 2023,
    rating: 9.4,
    description: '从秦王嬴政登基到一统六合的恢弘史诗。张鲁一、段奕宏等实力派演员倾情演绎，再现大秦帝国的崛起与辉煌。气势磅礴的历史正剧。',
    longDescription: '《大秦帝国之天下》是"大秦帝国"系列的收官之作，讲述了秦始皇嬴政从登上王位到统一六国的波澜壮阔的一生。本剧以严谨的历史态度和精良的制作水准，再现了两千多年前那段群雄逐鹿、百家争鸣的恢弘历史。战争场面宏大壮观，服饰道具考究精致，人物塑造立体丰满。张鲁一饰演的嬴政、段奕宏饰演的吕不韦等角色都给观众留下了深刻印象。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20drama%20poster%2C%20Qin%20dynasty%20emperor%20in%20black%20and%20red%20royal%20robe%20standing%20before%20ancient%20Chinese%20palace%2C%20thousands%20of%20terracotta%20warriors%20in%20background%2C%20dramatic%20sky%2C%20epic%20cinematic%20composition%2C%20dark%20moody%20tone&width=800&height=1120&seq=video-v004&orientation=portrait',
    tags: ['历史', '正剧', '战争', '秦朝'],
    director: '延艺 / 顾其铭',
    actors: ['张鲁一', '段奕宏', '李乃文'],
    region: '中国大陆',
    duration: '45分钟/集 共78集',
    updateStatus: '已完结',
    views: 45600000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v005',
    title: '乘风破浪的姐姐 第五季',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 8.9,
    description: '三十位30+女艺人重新出发，突破自我，挑战无限可能。舞台精彩纷呈，姐姐们的勇气与魅力点燃整个夏天。热门综艺全新一季强势回归。',
    longDescription: '《乘风破浪的姐姐》第五季强势回归，本季邀请了三十位来自不同领域的30+女性艺人，她们将在这个舞台上突破年龄的界限，挑战全新的自己。从唱跳到创作，从个人战到团队协作，姐姐们用实力证明：年龄从来不是限制，勇气和热爱才是最美的模样。本季舞美设计全面升级，每一场公演都堪称视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20style%2C%20group%20of%20elegant%20mature%20Chinese%20female%20celebrities%20in%20stunning%20stage%20costumes%20posing%20confidently%2C%20vibrant%20stage%20lighting%20with%20sparkles%2C%20glamorous%20atmosphere%2C%20warm%20golden%20and%20pink%20tones&width=800&height=1120&seq=video-v005&orientation=portrait',
    tags: ['真人秀', '音乐', '竞技', '女性'],
    director: '晏吉',
    actors: ['宁静', '那英', '王心凌', '薛凯琪'],
    region: '中国大陆',
    duration: '90分钟/期 共12期',
    updateStatus: '更新至第8期',
    views: 67800000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v006',
    title: '斗罗大陆之双神战双神',
    category: '动漫',
    categorySlug: 'anime',
    year: 2024,
    rating: 9.1,
    description: '唐三成神之路终极一战！双神降临，震撼对决。国漫顶级制作水准，玄机科技倾力打造，每一帧都是视觉享受。斗罗十年，热血不灭！',
    longDescription: '《斗罗大陆之双神战双神》是斗罗大陆动画系列的最新剧场版，讲述了唐三在继承海神神位后，与修罗神展开终极对决的史诗故事。本片由玄机科技倾力打造，采用了最新的动画渲染技术，战斗场面华丽炫目，特效制作达到了国产动画的顶级水准。唐三、小舞等经典角色的成长与情感线也得到了充分的展现，是为斗罗粉丝献上的一份诚意满满的视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20style%2C%20powerful%20male%20character%20with%20blue%20spirit%20powers%20surrounded%20by%20energy%20waves%2C%20dynamic%20battle%20pose%2C%20fantasy%20elements%2C%20cool%20blue%20and%20white%20color%20scheme%2C%20anime%20art%20style&width=800&height=1120&seq=video-v006&orientation=portrait',
    tags: ['热血', '玄幻', '战斗', '玄机科技'],
    director: '沈乐平',
    actors: ['沈磊', '陶典', '黄莺'],
    region: '中国大陆',
    duration: '120分钟',
    updateStatus: '已完结',
    views: 34100000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'v007',
    title: '繁花',
    category: '电视剧',
    categorySlug: 'drama',
    year: 2023,
    rating: 9.6,
    description: '王家卫首部电视剧，胡歌、马伊琍、唐嫣主演。九十年代上海滩风云变幻，黄河路上的人情冷暖与商海沉浮。极致美学，现象级作品。',
    longDescription: '《繁花》是王家卫导演的首部电视剧，改编自金宇澄的同名小说。故事以上世纪九十年代的上海为背景，讲述了阿宝（胡歌饰）在黄河路的商海沉浮与人生百态。王家卫独特的影像美学在剧中得到了完美的呈现，每一帧画面都如同精心构图的摄影作品。胡歌、马伊琍、唐嫣、辛芷蕾等演员的表演细腻入微，将那个年代的上海风情与人情世故演绎得淋漓尽致。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20style%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20elegant%20man%20in%201990s%20Shanghai%20style%20suit%20walking%20on%20neon-lit%20street%20at%20night%2C%20warm%20golden%20and%20red%20neon%20tones%2C%20nostalgic%20atmosphere%2C%20cinematic%20composition&width=800&height=1120&seq=video-v007&orientation=portrait',
    tags: ['年代', '商战', '爱情', '王家卫'],
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    duration: '45分钟/集 共30集',
    updateStatus: '已完结',
    views: 105000000,
    isHot: true,
    isNew: false,
    featuredOrder: 4,
  },
  {
    id: 'v008',
    title: '熊出没之逆转时空',
    category: '动漫',
    categorySlug: 'anime',
    year: 2024,
    rating: 8.8,
    description: '光头强意外获得穿越时空的能力，与熊大熊二展开了一场跨越时空的奇妙冒险。合家欢动画电影，笑料与温情并存。',
    longDescription: '《熊出没之逆转时空》是熊出没系列的最新动画电影。光头强在一次意外中获得了穿越时空的能力，他和熊大、熊二一起穿越到了不同的时代，经历了恐龙时代、古代中国、未来世界等奇妙冒险。影片保持了熊出没系列一贯的幽默风格，同时加入了更多关于友情和家庭的温情元素，是一部适合全家人一起观看的合家欢电影。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20poster%2C%20cute%20cartoon%20bear%20characters%20and%20a%20man%20traveling%20through%20time%20portal%2C%20colorful%20whimsical%20style%2C%20family-friendly%20vibe%2C%20bright%20cheerful%20colors%2C%20adventure%20theme&width=800&height=1120&seq=video-v008&orientation=portrait',
    tags: ['动画', '喜剧', '冒险', '合家欢'],
    director: '林汇达',
    actors: ['谭笑', '张伟', '张秉君'],
    region: '中国大陆',
    duration: '99分钟',
    updateStatus: '已完结',
    views: 41200000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'v009',
    title: '封神第一部：朝歌风云',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 9.0,
    description: '乌尔善十年磨一剑，打造中国神话史诗巨制。商王殷寿暴虐无道，姬发踏上反抗之路。顶级视效与宏大叙事，重新定义中国奇幻电影。',
    longDescription: '《封神第一部：朝歌风云》是导演乌尔善历时十年打造的中国神话史诗三部曲的开篇之作。影片以商朝末年为背景，讲述了商王殷寿（费翔饰）与狐妖妲己勾结、暴虐无道，引发天谴的故事。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主以救苍生。影片在视觉效果上投入巨大，雷震子、申公豹等神话角色的呈现令人惊艳，战斗场面气势恢宏。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20film%20poster%2C%20ancient%20Chinese%20warriors%20riding%20mythical%20beasts%20in%20battle%2C%20thunder%20and%20lightning%20in%20sky%2C%20palace%20in%20background%2C%20epic%20cinematic%20composition%2C%20dramatic%20dark%20red%20and%20gold%20tones&width=800&height=1120&seq=video-v009&orientation=portrait',
    tags: ['神话', '奇幻', '史诗', '乌尔善'],
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    duration: '148分钟',
    updateStatus: '已完结',
    views: 38900000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v010',
    title: '哈哈哈哈哈 第四季',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 8.5,
    description: '邓超、陈赫、鹿晗再度合体，自驾旅行真人秀。一路上有笑有泪，真实又温暖。五哈旅行团带你走遍中国，感受旅途中的美好。',
    longDescription: '《哈哈哈哈哈》第四季延续了前三季的旅行模式，邓超、陈赫、鹿晗组成的"五哈旅行团"再度出发。本季他们驾驶房车穿越中国大江南北，在旅途中体验各地的风土人情，完成各种有趣的任务和挑战。节目保持了轻松愉快的基调，三位MC之间的默契互动笑料不断，同时也展现了旅途中真实感人的瞬间，是一档让人放松心情的优质综艺。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20three%20male%20celebrities%20laughing%20and%20driving%20an%20RV%20on%20scenic%20Chinese%20road%2C%20beautiful%20mountain%20landscape%20background%2C%20bright%20sunny%20day%2C%20friendly%20vibe%2C%20warm%20natural%20colors&width=800&height=1120&seq=video-v010&orientation=portrait',
    tags: ['真人秀', '旅行', '喜剧', '户外'],
    director: '王征宇',
    actors: ['邓超', '陈赫', '鹿晗'],
    region: '中国大陆',
    duration: '90分钟/期 共12期',
    updateStatus: '更新至第6期',
    views: 56700000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v011',
    title: '姜子牙',
    category: '电影',
    categorySlug: 'movie',
    year: 2020,
    rating: 8.3,
    description: '封神大战后，姜子牙因一念之过被贬下凡间。失去神力的他，在追寻真相的旅途中重新发现自我。国产动画又一力作，画面精美。',
    longDescription: '《姜子牙》是光线彩条屋影业出品的动画电影。故事发生在封神大战之后，昆仑弟子姜子牙因在封神过程中一时心软被贬下凡间，失去神力。在凡间的旅途中，他遇到了神秘的少女小九，两人一同踏上了探寻真相的旅程。影片画面精美，具有强烈的东方美学风格，在探讨"救一人还是救苍生"的命题上有着深刻的思考。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20style%2C%20elderly%20sage%20with%20white%20beard%20in%20traditional%20Chinese%20robe%20standing%20on%20cliff%20overlooking%20misty%20mountains%2C%20ink%20wash%20painting%20aesthetic%2C%20ethereal%20atmosphere%2C%20cool%20silver%20and%20white%20tones&width=800&height=1120&seq=video-v011&orientation=portrait',
    tags: ['动画', '神话', '奇幻', '冒险'],
    director: '程腾 / 李炜',
    actors: ['郑希', '杨凝', '图特哈蒙'],
    region: '中国大陆',
    duration: '110分钟',
    updateStatus: '已完结',
    views: 45600000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v012',
    title: '天官赐福 第二季',
    category: '动漫',
    categorySlug: 'anime',
    year: 2024,
    rating: 9.4,
    description: '花城与谢怜的故事继续。为你明灯三千，为你花开满城。国漫顶级制作，唯美画风与深情故事，令无数观众感动落泪。',
    longDescription: '《天官赐福》第二季延续了第一季的高水准制作。故事讲述了八百年前谢怜第三次飞升后，与绝境鬼王花城相遇，两人在解决各种诡异事件的过程中，逐渐揭开了八百年前的真相。本季在画面上更加精益求精，每一帧都如同一幅精美的插画。花城与谢怜之间的情感刻画更加细腻深刻，"为你明灯三千"的经典场景感动了无数观众。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20poster%20style%2C%20two%20beautiful%20male%20characters%20in%20flowing%20ancient%20Chinese%20robes%2C%20surrounded%20by%20floating%20lanterns%20and%20cherry%20blossoms%2C%20ethereal%20romantic%20atmosphere%2C%20soft%20pink%20and%20gold%20color%20palette&width=800&height=1120&seq=video-v012&orientation=portrait',
    tags: ['玄幻', '古风', '爱情', '唯美'],
    director: '李豪凌',
    actors: ['姜广涛', '马正阳', '赵路'],
    region: '中国大陆',
    duration: '24分钟/集 共12集',
    updateStatus: '已完结',
    views: 63400000,
    isHot: true,
    isNew: false,
  },
];

export const featuredVideos = videos
  .filter(v => v.featuredOrder)
  .sort((a, b) => (a.featuredOrder || 99) - (b.featuredOrder || 99));

export const hotVideos = videos
  .filter(v => v.isHot)
  .sort((a, b) => b.views - a.views);

export const newVideos = videos
  .filter(v => v.isNew)
  .sort((a, b) => b.year - a.year);

export const rankingVideos = [...videos]
  .sort((a, b) => b.views - a.views)
  .slice(0, 10);

export function getVideoById(id: string): VideoItem | undefined {
  return videos.find(v => v.id === id);
}

export function getVideosByCategory(slug: string): VideoItem[] {
  return videos.filter(v => v.categorySlug === slug);
}

export function getRelatedVideos(video: VideoItem, limit: number = 6): VideoItem[] {
  return videos
    .filter(v => v.id !== video.id && v.categorySlug === video.categorySlug)
    .slice(0, limit);
}